<template>
  <div class="section recommend">
    <div class="h-tt">
      <h2>最热推荐</h2>
      <a
        href="javascript:;"
        class="more"
        @click="
          $router.push('/all-game')
          $util.clickStat(`GWSY/ZRTJ/SYYX`, `官网首页/最热推荐/所有游戏`)
        "
      >
        所有游戏
      </a>
    </div>
    <GameList
      :list="games"
      :stat-params="statParams"
      @hover="reportHover"
      @click-game="reportClick"
    />
  </div>
</template>

<script>
import GameList from '~/components/logic-common/GameList'
export default {
  components: {
    GameList
  },
  data() {
    return {
      games: [],
      statParams: {
        eid: 'GWSY/ZRTJ/YX',
        eid_desc: '官网首页/最热推荐/游戏'
      }
    }
  },
  created() {
    if (process.client) {
      this.$request('hotRecommend').then((data = []) => {
        this.games = data
      })
    }
  },
  methods: {
    reportHover({ game_id, title }, rn) {
      this.$xlaPush('home_page_game_content_hover', {
        rn,
        area: 'hot_rec',
        game_id,
        game_name: title
      })
    },
    reportClick(click_id, { game_id, title: game_name }, rn) {
      this.$xlaPush('home_page_game_content_click', {
        rn,
        area: 'hot_rec',
        game_id,
        game_name,
        click_id
      })
    },
    getHotClass({ hot_name }) {
      return {
        'min-tab': true,
        'hot-tab': hot_name === 'hot',
        'new-tab': hot_name === 'new'
      }
    }
  }
}
</script>
